<template lang="pug">
.briq-form-element.briq-time-input(v-bind="$attrs")
  label(v-if="label" :for="name") {{ label }}
  briq-required-and-optional-markers(:isRequired="this.$attrs.required" :isDisabled="this.$attrs.disabled || this.$attrs.readonly" :hideOptionalMarker="hideOptionalMarker" :label="label")
  VueTimepicker.time-picker(
    v-if="readyAfterReset"
    v-model="innerValue"
    :format="timeFormat"
    :disabled="this.$attrs.disabled || this.$attrs.readonly"
    :placeholder="placeHolder"
    :hide-clear-button="hideClearButton"
    v-bind="$attrs"
    )
    template(v-slot:clearButton)
      BriqIcon(name="icon-cross-error-icon")
  input(hidden :name="name" :value="value" v-bind="$attrs" ref="hidden")
  .validation-message(v-if="error" data-test-id="briq-time-input-error") {{ error }}
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import { shouldEmit, getEmitValue, convertTo12HourObject } from './briqTimeInputHelper.js'

export default {
  name: 'BriqTimeInput',
  components: { VueTimepicker },
  inheritAttrs: false,
  props: {
    name: String,
    label: { type: String, default: '' },
    error: String,
    hideOptionalMarker: Boolean,
    value: String,
    twelveHourClock: Boolean,
    emitSeconds: Boolean,
    format: String,
    hideClearButton: Boolean,
    placeHolder: { type: String, default: '' },
  },
  data() {
    return {
      readyAfterReset: true, // used to force rerender of VueTimepicker when value is set to null
      hasMounted: false,
    }
  },
  computed: {
    innerValue: {
      get() {
        if (!this.value) return null
        const value = this.getParsedValue(this.value)
        if (this.twelveHourClock) {
          return convertTo12HourObject(value)
        } else {
          const splits = value.split(':')
          return { HH: splits[0], mm: splits[1] }
        }
      },
      set(value) {
        if (!this.hasMounted) return // to prevent emitting on mount
        if (!value) {
          // used to force rerender of VueTimepicker when value is set to null
          this.readyAfterReset = false
          this.$nextTick(() => {
            this.readyAfterReset = true
          })
          return
        }
        if (!shouldEmit(this.twelveHourClock)(value)) return
        const emitValue = getEmitValue(this.twelveHourClock, this.emitSeconds)(value)
        this.$emit('input', emitValue)
      },
    },
    timeFormat() {
      if (this.format) return this.format
      return this.twelveHourClock ? 'hh:mm A' : 'HH:mm'
    },
  },
  methods: {
    getParsedValue(value) {
      const splitValue = value.split('.')
      return splitValue[1] !== undefined ? splitValue[1] : value
    },
  },
  mounted() {
    // needed to prevent emitting received value prop
    this.$nextTick(() => {
      this.$nextTick(() => {
        this.hasMounted = true
      })
    })
  },
}
</script>

<style lang="stylus">
.briq-time-input
  .time-picker
    display block
    background-color white

    &:after
      content ''
      width 17px
      height 17px
      // background-image url("/images/time-icon.svg") // todo: move this icon to BriqIconDefs (tried before; has viewbox issues)
      background-repeat no-repeat
      background-position center
      background-size 100%
      position absolute
      top 11px
      right 11px

    .clear-btn
      font-size 1em
      padding 0 0.7em
      height 100%
</style>
